import React from 'react';
import { columnType } from './CleanUpTable';
import IconButton from '../../components/Buttons/IconButton';
import { usePageContext } from '../../context/PageContext';

const ColumnViewRowDetails = (getTableDetails, renderRowDetailsAddOnButtons) => {
  const { openRowDetailsModal, customFieldName } = usePageContext();
  return {
    name: 'View Row Details',
    label: 'View Row Details',
    type: columnType.buttons,
    options: {
      display: true,
      setCellProps: () => {
        return {
          style: { padding: 1, width: 10 },
        };
      },
      customBodyRender: (_, tableMeta) => {
        return (
          <div>
            <IconButton
              icon="receipt"
              text="View Row Details"
              onClick={async () => {
                const { columns, title } = getTableDetails();
                const data = columns
                  .filter(
                    (col) => col?.options?.display !== 'excluded' && !col?.options?.hidden
                  )
                  .map((col, index) => {
                    const value = tableMeta.rowData[index + 1];
                    let customRender;
                    let listSeparator = '';

                    if (col?.type === columnType.list) {
                      listSeparator = col?.options?.listSeparator;
                    } else if (col?.options?.customBodyRender) {
                      customRender = () => {
                        return col.options.customBodyRender(value, tableMeta);
                      };
                    } else if (col?.options?.customBodyRenderLite) {
                      customRender = () => {
                        return col.options.customBodyRenderLite(
                          tableMeta.rowIndex,
                          true // isDisabledFromRowDetails - custom property to disable fields when used in row details
                        );
                      };
                    }

                    return {
                      label: customFieldName(col.label),
                      value: value,
                      type: col.type || '',
                      customRender: customRender,
                      listSeparator: listSeparator,
                      detailsGroup: col.detailsGroup || '',
                    };
                  });
                openRowDetailsModal(data, title, renderRowDetailsAddOnButtons);
              }}
            />
          </div>
        );
      },
    },
  };
};

export default ColumnViewRowDetails;
